import { __assign, __read, __spreadArray } from "tslib";
import update from 'immutability-helper';
import { useMutation } from 'react-apollo';
import { showErrorNotification } from '../../ToastContainer';
import { ADD_MEMBERS_TO_TEAM, GET_GROUP_MEMBERS } from '../graphql';
import cacheUpdateCompanyMembers from '../graphql/cache/cacheUpdateCompanyMembers';
var toastId = 'addMembers';
export default function useAddMembersToTeamMutation() {
    var _a = __read(useMutation(ADD_MEMBERS_TO_TEAM)), addMembersToTeam = _a[0], rest = _a.slice(1);
    return __spreadArray([
        function (_a) {
            var teamPk = _a.teamPk, members = _a.members;
            var emails = members.map(function (member) { return member.email; });
            addMembersToTeam({
                variables: {
                    teamPk: teamPk,
                    emails: emails,
                },
                update: function (cache, response) {
                    var addedMembers = response.data.addMembersToTeam.succeeded;
                    var addedEmails = addedMembers.map(function (_a) {
                        var email = _a.email;
                        return email;
                    });
                    cacheUpdateCompanyMembers(cache, {
                        teamPk: teamPk,
                        emails: addedEmails,
                    }, function (member) { return (__assign(__assign({}, member), { isTeamMember: true })); });
                    cacheAddMembersToTeam(cache, {
                        teamPk: teamPk,
                        members: addedMembers,
                    });
                },
                optimisticResponse: {
                    addMembersToTeam: {
                        __typename: 'AddMembersToTeam',
                        succeeded: members,
                        failed: [],
                    },
                },
            })
                .then(function (_a) {
                var data = _a.data;
                if (data.addMembersToTeam.failed.length) {
                    showErrorNotification({
                        toastId: toastId,
                        content: "There was an issue trying to add a user to this group. Please try again later",
                    });
                }
            })
                .catch(function () {
                showErrorNotification({
                    toastId: toastId,
                    content: 'Oops, something went wrong. Try again later',
                });
            });
        }
    ], __read(rest), false);
}
function cacheAddMembersToTeam(cache, _a) {
    var teamPk = _a.teamPk, members = _a.members;
    var queryProps = {
        query: GET_GROUP_MEMBERS,
        variables: { teamPk: teamPk },
    };
    var data = cache.readQuery(queryProps);
    var updatedData = update(data, {
        team: {
            members: {
                edges: {
                    $push: members.map(function (member) { return ({
                        isTeamMember: true,
                        node: member,
                        __typename: 'MemberEdge',
                    }); }),
                },
            },
        },
    });
    cache.writeQuery(__assign(__assign({}, queryProps), { data: updatedData }));
}
